module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/components/footer/footer.component.scss
// module id = ./src/app/components/footer/footer.component.scss
// module chunks = main